import React from "react";
import './src/styles/global.css';
import './src/styles/lookbook.css';
import 'swiper/swiper-bundle.css';
import "swiper/css"
import "swiper/css/pagination"
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css'
import "react-toastify/dist/ReactToastify.css"

import { QuickBuyProvider } from './src/context/QuickBuyContext.jsx'
import { BBxBratzProvider } from './src/context/BBxBratzContext.jsx'
import { StoreProvider } from './src/context/StoreContext.jsx'
import { AllProductsProvider } from './src/context/AllProductsContext.jsx'
import { UserProvider } from './src/context/UserContext.jsx'
import { ToastContainer } from "react-toastify"

//import { ApolloProvider } from '@apollo/client';
//import client from './src/context/apollo';


export const wrapRootElement = ({ element }) => (
    <React.StrictMode>
		<AllProductsProvider>
			<QuickBuyProvider>
				<UserProvider>
					<BBxBratzProvider>
						<StoreProvider>{element}</StoreProvider>
					</BBxBratzProvider>
				</UserProvider>
			</QuickBuyProvider>
			<ToastContainer
				position='top-right'
				autoClose={3000} 
				hideProgressBar
				closeButton={false}
				toastClassName={() => 'p-0'}
			/>
		</AllProductsProvider>
	</React.StrictMode>
    //<ApolloProvider client={client}></ApolloProvider>
)

export const onInitialClientRender = () => {
    
    document.addEventListener(
        "geCartAttributes",
        (event) => {
            console.log("im triggered")
            console.log(event)
            
            if (event.detail && event.detail.attributes) {
            console.log("Received geCartAttributes event:", event.detail.attributes);
            
            // Example: Update Shopify cart attributes via GraphQL API
            }
        },
        false
    );
    
    console.log("geCartAttributes event listener added!");
   
}